import { capitalize } from '@/utils/capitalize';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import { Flex, Tag } from '@chakra-ui/react';
import { palette } from './palette';
import { templateTypeOptions } from '@/utils/coding-details';

export const TemplatesTypeRenderer = ({ value }: CustomCellRendererProps) => {
    const templateOption = templateTypeOptions.find((opt) => opt.value === value);

    return (
        <Flex height="100%" alignItems="start" pt="3">
            <Tag.Root colorPalette={palette[templateOption?.value as keyof typeof palette]}>
                <Tag.Label>{capitalize(templateOption?.label || '')}</Tag.Label>
            </Tag.Root>
        </Flex>
    );
};
